import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingUnitDetailsComponent } from './building-unit-details.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { UnitOptionComponent } from './unit-option/unit-option.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateUserModule } from './create-user/create-user.module';
import { ActivityModule } from 'src/app/shared-layout/Components/activity/activity.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddLockModule } from './add-lock/add-lock.module';
import { DeviceManagementModule } from './device-management/device-management.module';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { ViewAlertDetailsComponent } from './view-alert-details/view-alert-details.component';
import { UpdateFirmwareDetailsComponent } from './update-firmware-details/update-firmware-details.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { UserProfileModule } from 'src/app/user-management/user-profile/user-profile.module';

@NgModule({
  declarations: [
    BuildingUnitDetailsComponent,
    UnitOptionComponent,
    ViewAlertDetailsComponent,
    UpdateFirmwareDetailsComponent,
  ],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    MatButtonToggleModule,
    ControlDisabledDirectiveModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    CreateUserModule,
    FormsModule,
    ActivityModule,
    NgbModule,
    AddLockModule,
    DeviceManagementModule,
    SortByModule,
    LazyLoadImageModule,
    TranslateModule,
    UserProfileModule,
  ],
  exports: [BuildingUnitDetailsComponent],
  providers: [LocalizationService, TranslateModule],
})
export class BuildingUnitDetailsModule {}
